<template>
  <NotificationsToastBase width="340px" v-bind="$attrs" v-on="$listeners">
    <template slot="body" slot-scope="props">
      <div
        class="notification-toast"
        :class="{
          [`notification-toast-${props.item.type}`]: true,
          'notification-toast-simple':
            !props.item.text &&
            props.item.data &&
            props.item.data.disableActions,
        }"
      >
        <div class="notification-toast-header">
          <SvgIcon
            :name="`components/${getIconName(props.item.type)}`"
            width="16"
            height="16"
            class="badge-icon"
          />
          <span class="title">{{ props.item.title }}</span>
          <a
            v-if="!props.item.data || !props.item.data.disableCloseIcon"
            href="#close"
            class="close-icon"
            @click.prevent="props.close"
          >
            <SvgIcon name="components/remove-alt" width="16" height="16" />
          </a>
        </div>

        <!-- eslint-disable vue/no-v-html -->
        <div
          v-if="props.item.text"
          class="notification-toast-body"
          v-html="props.item.text"
        />

        <div
          v-if="!props.item.data || !props.item.data.disableActions"
          class="notification-toast-footer"
        >
          <a
            v-if="
              props.item.data &&
              props.item.data.actionText &&
              props.item.data.actionCallback
            "
            href="#action"
            @click.prevent="executeActionCallback(props)"
          >
            {{ props.item.data.actionText }}
          </a>

          <a href="#close" @click.prevent="props.close"> Dismiss </a>
        </div>
      </div>
    </template>
  </NotificationsToastBase>
</template>

<script>
import SvgIcon from 'vue-svgicon'

import '../../icons/components/info'
import '../../icons/components/error'
import '../../icons/components/warning-alt'
import '../../icons/components/check-small'
import '../../icons/components/remove-alt'

export default {
  components: {
    SvgIcon,
  },
  inheritAttrs: false,
  methods: {
    getIconName(type) {
      const icons = {
        error: 'error',
        warning: 'warning-alt',
        warn: 'warning-alt',
        success: 'check-small',
      }

      return icons[type] || 'info'
    },
    executeActionCallback(props) {
      try {
        props.item.data.actionCallback(props.item)
      } catch (error) {
        console.error(error)
      }

      props.close()
    },
  },
}
</script>

<style lang="scss">
.vue-notification-group {
  position: fixed;
  z-index: 999999;
}

.notification-toast {
  padding: 1rem;
  margin: 1rem;
  font-size: $font-size-sm;
  color: $gray-900;
  border-radius: 2px;
  box-shadow: 0 2px 8px 0 rgba(37, 37, 37, 0.16),
    0 0 4px 0 rgba(37, 37, 37, 0.08);
  border: 1px solid $cyan-700;
  background-color: #fff;

  .badge-icon {
    color: $cyan-700;
    margin-right: 0.5rem;
  }

  .close-icon {
    display: inline-flex;
    color: $gray-900;
  }

  &-simple {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;

    .title {
      font-weight: normal !important;
    }
  }

  &-header {
    display: flex;
    // justify-content: space-between;
    align-items: center;

    .title {
      flex-grow: 1;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: normal;
    }
  }

  &-body,
  &-footer {
    margin-left: 1.5rem;
  }

  &-body {
    max-width: 218px;
  }

  &-footer {
    margin-top: 1.125rem;

    a,
    a:hover {
      color: $cyan-700;
    }

    a {
      margin-right: 1rem;
    }
  }

  &-warn {
    border-color: $orange-700;

    .badge-icon {
      color: $orange-700;
    }
  }

  &-error {
    border-color: $red-500;

    .badge-icon {
      color: $red-500;
    }
  }

  &-success {
    border-color: $green-700;

    .badge-icon {
      color: $green-700;
    }
  }
}
</style>
